import { AuthConfig } from "@auth0/auth0-angular";
import { Constants } from "../../constants";

export const authCodeFlowConfig: AuthConfig = {
    domain: Constants.stsAuthority,
    clientId: Constants.clientId,
    authorizationParams: {
        audience: Constants.audience,
        redirect_uri: window.location.origin,
        scope: "openid profile email offline_access",
    },
};
